import { createCustomSelector } from "@shared/hookHelpers";

const useCreateSelector =  createCustomSelector(({personDetail}) => personDetail);

export const useMainEmail = () => useCreateSelector((state) => state.person.data?.attributes.main_email);

